import React from 'react'

export default function About() {
  return (
    <div className=' relative after:content-[""] after:bg-gradient-to-b after:from-[#DEE1E4] after:to-[#c8dbda] after:bg-opacity-50 after:w-full after:h-full after:absolute after:bottom-0' id='about'>
      <div className='sm:grid flex sm:flex-none flex-col-reverse sm:grid-cols-2 sm:grid-rows-none gap-4 items-center justify-items-center py-[10%] px-[3%] '>
        <div className='text-center text-primary z-10'>
          <h1 className='md:text-5xl text-3xl font-bold mb-3'>About Me</h1>
          <p className='md:text-xl text-base font-medium'>Front End Developer with proven ability to develop user interfaces and build a responsive website. Highly skilled in HTML, CSS, JavaScript, React JS, and Next JS, also modern libraries and frameworks. Always manage to keep up with the latest developments in design and technology. Well-versed in Scrum and Agile. I graduated from Binar Academy Full Stack Web course to learn a new language while sharpening existing skills.</p>
        </div>
        <div className='z-10'>
          <img src="/assets/images/image221.png" alt="foto-profile" className='h-[350px] rounded-full' />
        </div>
      </div>
      <div className='absolute bottom-0 z-10 w-full'>
        <hr className='border border-[#8cb7be]' />
      </div>
    </div>
  )
}
